export enum DisplayType {
  BuiltInCheck = 0,
  Normal = 1,
  Link = 2,
  EyeIcon = 3,
  Custom = 4,
  CustomParent = 5,
  CustomChecked = 6,
  CustomGroupChecked = 7,
  Numeric = 8,
  Date = 9
}
